const userPrivileges = {
	view: [
		'extranet__admin__itemsRef_view', //0
		'extranet__admin__itemsLife_view',
		'extranet__admin__pricesByKiosk_view',
		'extranet__admin__pricesByItem_view',
		'extranet__admin__pricesChange_view',
		'extranet__admin__promotionsDetail_view', // 5
		'extranet__admin__salesOrder_history_byKiosk_view',
		'extranet__admin__salesOrder_byItem_view',
		'extranet__admin__salesOrder_userInfos_view',
		'extranet__admin__salesOrder_salesTicket_view',
		'extranet__admin__salesOrder_history_byCode_view', //10
		'extranet__admin__depositContract_view',
		'extranet__admin__salesOrder_notReconciled_view',
		'extranet__admin__paimentCollectionHistory_view',
		'extranet__admin__paimentCollectionDetail_view',
		'extranet__admin__stockManagement_view', //15
		'extranet__admin__usersManagement_view',
		'extranet__admin__rolesManagement_view',
		'extranet__admin__tagsManagement_view',
		'extranet__admin__rgpdManagement_view',
		'extranet__admin__companiesManagement_view', //20
		'extranet__admin__languageManagement_view',
		'extranet__admin__traductionManagement_view',
		'extranet__admin__logsHistory_users_view',
		'extranet__admin__logsHistory_kiosk_view',
		'extranet__admin__logsHistory_synchro_view', //25
		'extranet__admin__logsHistory_extranet_view',
		'extranet__admin__menu_myAccount_view',
		'extranet__admin__menu_goStore_codeGeneration_view',
		'extranet__admin__menu_setting_view',
		'extranet__admin__menu_dashboard_view', //30
		'extranet__admin__itemsCatalog_link_view',
		'extranet__admin__kioskRequest_business_view',
		'extranet__admin__kioskRequest_customer_view',
		'extranet__admin__salesOrder_salesCustomerTicket_view',
		'extranet__admin__marketing_view', //35
		'extranet__admin__initKiosksProduction_kioskList_view',
		'extranet__admin__kioskCatalog_view',
		'extranet__admin__kioskUpdate_view',
		'extranet__admin__rackUpdate_view',
		'extranet__admin__kioskUpdateImplantation_view', //40
		'extranet__admin__kioskLog_view',
		'extranet__admin__kioskTransactionAnalysis_view',
		'ref__applicationPrivilege__extranet__admin__statistics_view'
	],
	reporting: [
		'extranet__admin__salesOrder_byKiosk_analyze',
		'extranet__admin__salesOrder_byItem_analyze',
		'extranet__admin__salesOrder_notReconciled_analyze',
		'extranet__admin__logs_users_analyze',
		'extranet__admin__logs_kiosk_analyze',
		'extranet__admin__logs_synchro_analyze',
		'extranet__admin__logs_extranet_analyze',
	],
	export: [
		'extranet__admin__itemsRef_export', //0
		'extranet__admin__pricesByKiosk_export',
		'extranet__admin__pricesByItem_export',
		'extranet__admin__pricesChange_export',
		'extranet__admin__promotions_export',
		'extranet__admin__salesOrder_byKiosk_export', //5
		'extranet__admin__salesOrder_byItem_export',
		'extranet__admin__salesOrder_byCode_export',
		'extranet__admin__depositContract_export',
		'extranet__admin__salesOrder_notReconciled_export',
		'extranet__admin__paimentCollectionHistory_export', //10
		'extranet__admin__stockManagement_export',
		'extranet__admin__logs_users_export',
		'extranet__admin__logs_kiosk_export',
		'extranet__admin__logs_synchro_export',
		'extranet__admin__logs_extranet_export', //15
		'extranet__admin__kioskRequest_business_export',
		'extranet__admin__kioskRequest_customer_export',
		'extranet__admin__logs_extranet_export',
		'extranet__admin__marketing_export',
		'extranet__admin__initKiosksProduction_kioskList_export', // 20
		'extranet__admin__salesOrder_byKiosk_merchantTicket_export',
		'extranet__admin__kioskLog_export',
		'extranet__admin__kioskTransactionAnalysis_export',
	],
	action: [
		'extranet__admin__itemsRef_manage', //0
		'extranet__admin__itemsLife_manage',
		'extranet__admin__pricesChange_manage',
		'extranet__admin__promotions_manage',
		'extranet__admin__salesOrder_userInfos_manage',
		'extranet__admin__salesOrder_byCode_manage', //5
		'extranet__admin__depositContract_manage',
		'extranet__admin__salesOrder_notReconciled_manage',
		'extranet__admin__paimentCollectionDetail_manage',
		'extranet__admin__stockManagement_manage',
		'extranet__admin__usersManagement_manage', //10
		'extranet__admin__rolesManagement_manage',
		'extranet__admin__tagsManagement_manage',
		'extranet__admin__rgpdManagement_manage',
		'extranet__admin__companiesManagement_manage',
		'extranet__admin__languageManagement_manage', //15
		'extranet__admin__traductionManagement_manage',
		'extranet__admin__logs_users_manage',
		'extranet__admin__logs_kiosk_manage',
		'extranet__admin__logs_synchro_manage',
		'extranet__admin__logs_extranet_manage', //20
		'extranet__admin__itemsCatalog_link_manage',
		'extranet__admin__kioskRequest_business_manage_listInProgress',
		'extranet__admin__kioskRequest_customer_manage_listInProgress',
		'extranet__admin__kioskCatalog_manage',
		'extranet__admin__kioskUpdate_manage', //25
		'extranet__admin__rackUpdate_manage',
		'extranet__admin__kioskUpdateImplantation_manage',
	],
	buttonAction: ['extranet__admin__userDetail_action_forcePasswordRenew', 'extranet__admin__kioskRequest_customer_manage_buttonActionCreation'],
}

export default userPrivileges
